import React from 'react';

import { Link } from 'react-router-dom';

import { useLogo } from '../../logoContext';


import TowerImage from '../../asset/images/hotel/ferris-wheel.svg';
import forwardIcon from '../../asset/images/icons/forward-icon.svg';

import logo from '../../asset/images/logos/snb-logo-1.png';
import strip from '../../asset/images/strip.svg'

import { BsPinMapFill } from 'react-icons/bs';

import rightIcon from '../../asset/images/icons/right-arrow-green.png'


import {PiPersonSimpleWalkBold} from 'react-icons/pi';


const MoreInfoPage = () => {

  
  document.title = 'Contact Us | SNB';

  const logoSrc = useLogo();

  return (
    <div className='outer-wrapper'>
      <div className='container-fluid main-content'>
        <div className='row header'>
        <Link style={{width: 'fit-content'}} to="/"><img className='ms-sm-3 ms-0' id='logo' src={logoSrc} alt='snb logo' /></Link>
          <h2 className='text-primary header-text'>2025 | SNB Nexus</h2>
        </div>

        <div className='px-4'>
        
        <div className="row nav">
          <div className="d-flex justify-content-end">
            <Link to="/home" className="text-decoration-none text-white">
              <button className="btn nav-btn d-flex align-items-center">
                <img src={forwardIcon} alt="" width="22%" className="me-auto" /> <span>Back</span>
              </button>
            </Link>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-2 col-12">
            <h2 type="button" className="text-primary text-bold text-start pb-3">
              More Info
            </h2>
          </div>

          <div className='col-lg-8 col-12'>
            <div className="row d-flex justify-content-center">

              <div className="col-md-8 col-12 mb-3">
                <div className="border border-2 border-success pb-2 shadow">
                  <h4 className="text-white bg-primary ps-3 py-2 text-center">Bvlgari Hotel</h4>
                  <span className='d-flex align-items-center m-3'>
                    <img src={rightIcon} className='me-2' height={'20px'} alt="right-arrow" /> 
                    <h5 className="text-primary mb-0">
                      171 Knightsbridge, London SW7 1DW, United Kingdom
                    </h5>
                  </span>
                  
                  <span className='d-flex align-items-center m-3'>
                    <img src={rightIcon} className='me-2' height={'20px'} alt="right-arrow" /> 
                    <h5 className="text-primary mb-0">
                        Bvlgari Hotel is 25 minutes from the Heathrow Airport
                    </h5>
                  </span>
                  <span className='d-flex align-items-center m-3'>
                    <img src={rightIcon} className='me-2' height={'20px'} alt="right-arrow" /> 
                    <h5 className="text-primary mb-0">
                        Transportation distance by car between Airport and the hotel is 45-60 minutes depending on rush hours
                    </h5>
                  </span>
                  <span className='d-flex align-items-center m-3'>
                    <img src={rightIcon} className='me-2' height={'20px'} alt="right-arrow" /> 
                    <h5 className="text-primary mb-0">
                        Navigate <PiPersonSimpleWalkBold/> with <a className='text-primary' target='_blank' href="https://www.google.com/maps/dir//Bulgari+Hotel+171+Knightsbridge,+London+SW7+1DW,+United+Kingdom/data=!4m6!4m5!1m1!4e2!1m2!1m1!1s0x4876054778418107:0xa0424328ebddc117?sa=X&ved=2ahUKEwjCqLj2gaWCAxWNSPEDHf18DjEQ9Rd6BAhkEAA">Google Maps</a>
                    </h5>
                  </span>
                </div>
              </div>

              <div className="col-md-8 col-12 mb-3">
                <div className="border border-2 border-success pb-2 shadow">
                  <h4 className="text-white bg-primary ps-3 py-2 text-center">Apollo’s Muse (Bacchanalia)</h4>
                  <span className='d-flex align-items-center m-3'>
                    <img src={rightIcon} className='me-2' height={'20px'} alt="right-arrow" /> 
                    <h5 className="text-primary mb-0">
                    1 Mount Street, London, W1K 3NA, United Kingdom
                    </h5>
                  </span>
                  <span className='d-flex align-items-center m-3'>
                    <img src={rightIcon} className='me-2' height={'20px'} alt="right-arrow" /> 
                    <h5 className="text-primary mb-0">
                    Bacchanalia Restaurant transportation by car is	approximately 15 minutes
                    </h5>
                  </span>
                  <span className='d-flex align-items-center m-3'>
                    <img src={rightIcon} className='me-2' height={'20px'} alt="right-arrow" /> 
                    <h5 className="text-primary mb-0">
                        Navigate <PiPersonSimpleWalkBold/> with <a className='text-primary' target='_blank' href="https://www.google.com/maps/dir//Bacchanalia,+1-3+Mount+St,+London+W1K+3NB,+United+Kingdom/@51.510577,-0.1503076,17z/data=!4m9!4m8!1m0!1m5!1m1!1s0x48760534c2ce9d7f:0x68a30e971e5c59fc!2m2!1d-0.1477327!2d51.5105737!3e0?entry=ttu">Google Maps</a>
                    </h5>
                  </span>
                </div>
              </div>

              
              <div className="col-md-8 col-12 mb-3">
                <div className="border border-2 border-success pb-2 shadow">
                  <h4 className="text-white bg-primary ps-3 py-2 text-center">Studio Frantzen- Harrods</h4>
                  <span className='d-flex align-items-center m-3'>
                    <img src={rightIcon} className='me-2' height={'20px'} alt="right-arrow" /> 
                    <h5 className="text-primary mb-0">
                    87-135 Brompton Road, Knightsbridge Fifth Floor, Harrods, London SW1X 7XL, United Kingdom
                    </h5>
                  </span>
                  <span className='d-flex align-items-center m-3'>
                    <img src={rightIcon} className='me-2' height={'20px'} alt="right-arrow" /> 
                    <h5 className="text-primary mb-0">
                      5 minutes walk from The Bvlgari Hotel
                    </h5>
                  </span>
                  <span className='d-flex align-items-center m-3'>
                    <img src={rightIcon} className='me-2' height={'20px'} alt="right-arrow" /> 
                    <h5 className="text-primary mb-0">
                        Navigate <PiPersonSimpleWalkBold/> with <a className='text-primary' target='_blank' href="https://www.google.com/maps/dir/31.4453191,74.2281203/Studio+Frantzen-+Harrods/@31.2228181,-5.8017579,3z/data=!3m1!4b1!4m9!4m8!1m1!4e1!1m5!1m1!1s0x48760551ac2512b9:0xb11f03da7acbc4a1!2m2!1d-0.1633341!2d51.4990638?entry=ttu">Google Maps</a>
                    </h5>
                  </span>
                </div>
              </div>

              
            </div>
          </div>

        </div>
        </div>

      </div>
      <span className='footer'>
      <img src={TowerImage} alt="" className="ms-0 ms-md-auto d-none d-md-block wheel-small p-absolute" />
        <img src={TowerImage} alt="" className="ms-0 ms-md-auto d-block d-md-none wheel-small"/>
        <h2 className='text-primary footer-text mx-0 ps-0 mx-md-4 ps-md-3' >SNB Nexus 2026
</h2>
        <img className='strip' src={strip} alt='footer' />
      </span>
    </div>
  );
};

export default MoreInfoPage;

